import React, { Component } from "react";
import { connect } from "react-redux";
import { defaultAction } from "../actions/defaultAction.js";
import { checkToken } from "../thunks/user_info";
import * as ActionTypes from "../constants/actionTypes";
import { resetPassword } from "../thunks/user_info";
import { initForgotPassword } from "../thunks/customerInfo.js";

//Components
import Loading from "../components/popups/loading.jsx";
import InvalidToken from "../components/passReset/invalidToken.jsx";
import ResetPass from "../components/passReset/resetPass.jsx";
import EmailSent from "../components/passReset/emailSent.jsx";
import Confirmation from "../components/passReset/confirmation.jsx";
import { Helmet } from "react-helmet";

class CheckPassToken extends Component {
  componentDidMount() {
    this.props.checkToken(this.props.match.params.token);
  }
  render() {
    let { userInfo } = this.props;

    let componentToRender;

    if (userInfo.get("displayLoading")) {
      return <Loading showLoading />;
    }

    if (userInfo) {
      let validToken = userInfo.get("validToken");
      let emailSent = userInfo.get("emailSent");
      let passReset = userInfo.get("passReset");
      componentToRender = passReset ? (
        <Confirmation />
      ) : emailSent ? (
        <EmailSent />
      ) : validToken ? (
        <ResetPass {...this.props} />
      ) : !validToken ? (
        <InvalidToken {...this.props} />
      ) : (
        <Loading showLoading />
      );
    }

    return (
      <div
        className="container top-indent"
        style={{ flex: "1", flexBasis: "100%" }}
      >
        <Helmet>
          <title>Password Assistance | {this.props.config.brand}</title>
        </Helmet>
        <div className="row">
          <div className="animated fadeInUp signin mar-b-40">
            <div className="box-outer mar-t-100">
              <div className="box-inner">{componentToRender}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    userInfo: state.userInfo,
    customerInfo: state.customerInfo,
    config: state.config,
  }),
  (dispatch) => ({
    checkToken: (token) => dispatch(checkToken(token)),
    updateErrors: (obj) =>
      dispatch(defaultAction(ActionTypes.UPDATE_ERRORS, obj)),
    setFirstPass: (firstPass) =>
      dispatch(defaultAction(ActionTypes.SET_FIRST_PASS, firstPass)),
    setSecondPass: (secondPass) =>
      dispatch(defaultAction(ActionTypes.SET_SECOND_PASS, secondPass)),
    setEmailAddress: (e) =>
      dispatch(
        defaultAction(ActionTypes.SET_RESET_PASSWORD_EMAIL, e.target.value)
      ),
    setErrorMsg: (msg) =>
      dispatch(defaultAction(ActionTypes.SET_ERROR_MSG, msg)),
    resetPassword: (token, password) =>
      dispatch(resetPassword(token, password)),
    setRecaptcha: (data) => {
      dispatch(defaultAction(ActionTypes.SET_RECAPTCHA, data));
    },
    initForgotPassword: (email, recaptchaCode, url) =>
      dispatch(initForgotPassword(email, recaptchaCode, url)),
    setRecaptcha: (data) =>
      dispatch(defaultAction(ActionTypes.SET_RECAPTCHA, data)),
  })
)(CheckPassToken);
